import React from 'react';
import ReactDOM from 'react-dom/client';
import MainPage from './MainPage';
import '../src/styles/index.css';

// Add favicon
const favicon = document.createElement('link');
favicon.rel = 'icon';
favicon.type = 'image/svg+xml';
favicon.href = 'images/favicon.svg';
document.head.appendChild(favicon);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <MainPage />
    </React.StrictMode>
);